import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    DefaultTemperatureRange,
    RejectionReason,
} from 'app/enums/label.enums'

import {
    RejectedContainerChangeType,
} from '../../longTermLease.types'

const getColumns = (
    l: (l: string) => string,
): RichTableColumns<keyof RejectedContainerChangeType>[] => {
    return [
        {
            id: 'containerSerialNumber',
            headerProps: {
                children: l('Container.serialNumber'),
            },
            mapCellProps: 'containerSerialNumber',
        },
        {
            id: 'containerJypId',
            headerProps: {
                children: l('Container.jypId'),
            },
            mapCellProps: 'containerJypId',
        },
        {
            id: 'containerContainerTypeContainerModel',
            headerProps: {
                children: l('ContainerType.containerModel'),
            },
            mapCellProps: 'containerContainerTypeContainerModel',
        },
        {
            id: 'containerTempRange',
            headerProps: {
                children: l('ContainerView.tempRange'),
            },
            componentName: 'EnumValue',
            allowedValuesEnum: DefaultTemperatureRange,
            mapCellProps: 'containerTempRange',
        },
        {
            id: 'rejectionReason',
            headerProps: {
                children: l('SelectedContainer.rejectionReason'),
            },
            componentName: 'EnumValue',
            allowedValuesEnum: RejectionReason,
            mapCellProps: 'rejectionReason',
        },
        {
            id: 'rejectionComment',
            headerProps: {
                children: l('SelectedContainer.rejectionComment'),
            },
            mapCellProps: 'rejectionComment',
        },
        {
            id: 'createdBy',
            headerProps: {
                children: l('Prebooking.modifiedBy'),
            },
            mapCellProps: 'createdBy',
        },
        {
            id: 'createdOn',
            headerProps: {
                children: l('Prebooking.modifiedOn'),
            },
            mapCellProps: 'createdOn',
        },
    ]
}

export default getColumns
